/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable camelcase */
import React from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import Select from 'react-select';

import NewUsersParams from '../../app/server/newUsersParams';
import ClientsAction from '../../app/store/actions/clients';
import { updateNewUsersParams } from '../../app/store/actions/newUsersParams';
import { loadSettings } from '../../app/store/actions/settings';
import FIELDS from '../../data/fields';
import TRANSLATE from '../../helpers/translate';
import Checkbox from '../form/parameters/components/checkbox';
import { config, permissionsInit } from '../form/parameters/data/permissions';
import {
  setCheckboxLabels,
  setInitialCheckboxsStatesAndValues,
  validateCheckboxPermissions,
} from '../form/parameters/helpers/permissionRules';
import VALIDATION from '../form/parameters/Validation';
import MultiSelect from '../multi-select/MultiSelect';
import SelectComponent from '../select/Select';

class NewUsersComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        client_str_freight: '',
        client_str_location: '',
        client_str_deposit: '',
        client_str_bu: '',
        client_int_price_policy: '',
        client_str_purpose: '',
        client_bol_display_client_description: '',
        client_bol_show_contract_product_without_price: '',
        client_bol_allow_sell_spot_itens_without_stock: '',
        client_bol_client_withdraw: '',
        client_bol_delivery_address_type: '',
        client_bol_internal_delivery_address: '',
        client_str_buy_button_label: I18n.t('addEstimate'),
        client_bol_file_email_json: 0,
        client_bol_file_email_xml: 0,
        client_bol_file_email_csv: 0,
        client_bol_file_email_pdf: 0,
        client_flo_minimum_purchase: 0,
        client_flo_minimum_product: 0,
        client_bol_automatic_billing: 0,
        emailsEkam: '',
      },
      listClient: '',
      message: '',
      success: '',
      permissions: permissionsInit,
      inputsStateDisabled: [],
      inputsLabel: [],
    };

    config.forEach((items) => {
      items.permissions.forEach((item) => {
        this.state.permissions[item.id] = false;
        this.state.inputsStateDisabled[item.id] = false;
        this.state.inputsLabel[item.id] = '';
      });
    });
  }

  async componentDidMount() {
    const params = await NewUsersParams.getNewUsersParams();
    this.setClientUpdate(params);
    await this.initCheckbox();
    const { inputsLabel } = this.state;
    const inputsL = await setCheckboxLabels(inputsLabel);
    await this.setState({ inputsLabel: inputsL });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.clients) {
      if (!prevState.listClient || (prevState.listClient !== this.state.listClient)) {
        this.renameDepositKeyForComponent(this.props.clients.stock[0]);
      }
    }
  }

  getPtbr = (values, val, id) => {
    if (id === 'purpose') {
      return TRANSLATE.clientPurpose(values[val]);
    } if (id === 'freight') {
      return TRANSLATE.clientFreight(values[val]);
    }
    return values[val];
  }

  getObjValues =
    (values, id) => (Object.keys(values).map(val => (
      <option key={values[val]} value={values[val]}>{this.getPtbr(values, val, id)}</option>)));

  getValuesLocation =
    values => (values.map(val => (
      <option key={val.id + val.crmTag} value={val.id}>
        {val.crmTag ? val.crmTag
          : `${val.id} - ${val.city}`}
      </option>
    )));

  getValues =
    values => (values.map(val => (<option key={val.id + val.description} value={val.id}>{val.description}</option>)));

  getValuesObj =
    values => ([{ label: '', value: '' }].concat(values.map(val => ({ label: val.description, value: val.id }))));

    getSelectEstabelecimento = (title, attr, values, body) => (
      <div className="form-group">
        <p className="margin-bottom-2">{title}</p>
        {(
        Object.keys(values).map((value, index) => (
          <div key={`${values[value]}${index}`} className="form-group row">
            <p htmlFor={`${title}_${values[value]}`} className="col-3 selectEstabelec-p">{value === 'SP' ? I18n.t('saoPauloCustomersEstablishment') : I18n.t('establishmentCustomersOutsideSaoPaulo')}</p>
            <div className="col selectEstabelec-row">
              <select
                onChange={e => this.selectedItem(attr, e)}
                className="custom-select"
                id={value === 'SP' ? 'clienteSaoPaulo' : 'clienteForaSaoPaulo'}
                value={values[value]}
                required
              >
                <option value="" />
                {body}
              </select>
            </div>
          </div>
        ))
      )}
      </div>
    )

  getSelectComponent = (title, attr, value, body, tooltip) => (
    <SelectComponent
      title={title}
      value={value}
      body={body}
      onChange={e => this.selectedItem(attr, e)}
      tooltip={tooltip}
    />
  )

  onCheckBox = async (e, id) => {
    const {
      permissions,
      inputsStateDisabled,
    } = validateCheckboxPermissions(e, id, this.state.permissions, this.state.inputsStateDisabled);
    await this.setState({ permissions, inputsStateDisabled });
  }

  initCheckbox = async () => {
    const {
      inputsStateDisabled,
      permissions,
    } = await setInitialCheckboxsStatesAndValues(this.state.permissions, this.state.inputsStateDisabled);
    this.setState({ inputsStateDisabled, permissions });
  }

  setMinimumPurchase = (minimum) => {
    const { form } = this.state;
    form.client_flo_minimum_purchase = minimum.floatValue;
    this.setState({
      form,
    });
  }

  setMinimumProduct = (minimum) => {
    const { form } = this.state;
    form.client_flo_minimum_product = minimum.floatValue;
    this.setState({
      form,
    });
  }

  setClientUpdate = async (item) => {
    const { form, permissions } = this.state;
    form.client_str_freight = item.client_str_freight;
    form.client_str_location = item.client_str_location;
    form.client_str_deposit = item.client_str_deposit;
    form.client_str_bu = item.client_str_bu;
    form.client_int_price_policy = item.client_int_price_policy;
    form.client_str_purpose = item.client_str_purpose;
    form.client_str_buy_button_label = item.client_str_buy_button_label;
    form.client_bol_display_client_description = item.client_bol_display_client_description ? 1 : 0;
    form.client_bol_show_contract_product_without_price = item.client_bol_show_contract_product_without_price ? 1 : 0;
    form.client_bol_allow_sell_spot_itens_without_stock = item.client_bol_allow_sell_spot_itens_without_stock ? 1 : 0;
    form.client_bol_client_withdraw = item.client_bol_client_withdraw ? 1 : 0;
    form.client_bol_delivery_address_type = item.client_bol_delivery_address_type ? 1 : 0;
    form.client_bol_internal_delivery_address = item.client_bol_internal_delivery_address ? 1 : 0;
    form.client_bol_file_email_csv = item.client_bol_file_email_csv ? 1 : 0;
    form.client_bol_file_email_pdf = item.client_bol_file_email_pdf ? 1 : 0;
    form.client_bol_file_email_xml = item.client_bol_file_email_xml ? 1 : 0;
    form.client_bol_file_email_json = item.client_bol_file_email_json ? 1 : 0;
    form.client_flo_minimum_purchase = item.client_flo_minimum_purchase;
    form.client_flo_minimum_product = item.client_flo_minimum_product;
    form.client_bol_automatic_billing = item.client_bol_automatic_billing ? 1 : 0;
    form.emailsEkam = item.emailsEkam;
    permissions.user_client_bol_permission_cart = item.user_client_bol_permission_cart ? 1 : 0;
    permissions.user_client_bol_permission_cart_users = item.user_client_bol_permission_cart_users ? 1 : 0;
    permissions.user_client_bol_permission_purchase_credit = item.user_client_bol_permission_purchase_credit ? 1 : 0;
    permissions.user_client_bol_permission_purchase_payment_gateway = item.user_client_bol_permission_purchase_payment_gateway ? 1 : 0;
    permissions.user_client_bol_permission_purchase_debit = item.user_client_bol_permission_purchase_debit ? 1 : 0;
    permissions.user_client_bol_permission_purchase_bank_slip = item.user_client_bol_permission_purchase_bank_slip ? 1 : 0;
    permissions.user_client_bol_permission_purchase_billing = item.user_client_bol_permission_purchase_billing ? 1 : 0;
    permissions.user_client_bol_permission_purchase_estimate = item.user_client_bol_permission_purchase_estimate ? 1 : 0;
    permissions.user_client_bol_permission_similarity = item.user_client_bol_permission_similarity ? 1 : 0;
    permissions.user_client_bol_permission_stock = item.user_client_bol_permission_stock ? 1 : 0;
    permissions.user_client_bol_permission_lead_time = item.user_client_bol_permission_lead_time ? 1 : 0;
    permissions.user_client_bol_permission_cross_selling = item.user_client_bol_permission_cross_selling ? 1 : 0;
    permissions.user_client_bol_permission_price = item.user_client_bol_permission_price ? 1 : 0;
    permissions.user_client_bol_permission_client_code = item.user_client_bol_permission_client_code ? 1 : 0;
    permissions.user_client_bol_permission_spot = item.user_client_bol_permission_spot ? 1 : 0;
    permissions.user_client_bol_permission_opic_code = item.user_client_bol_permission_opic_code ? 1 : 0;
    permissions.user_client_bol_permission_sonepar_code = item.user_client_bol_permission_sonepar_code ? 1 : 0;
    permissions.user_client_bol_permission_visualize_all_orders = item.user_client_bol_permission_visualize_all_orders ? 1 : 0;
    permissions.user_client_bol_permission_allow_mixed_purchase = item.user_client_bol_permission_allow_mixed_purchase ? 1 : 0;
    item.client_str_deposit = item.client_str_deposit.toUpperCase();

    await this.props.getClientSettings();
    await this.setState({
      form,
      permissions,
      message: '',
      checked: item.client_str_deposit ? item.client_str_deposit.split(',') : null,
    });
  }

  saveClient = async () => {
    const {
      client_bol_display_client_description,
      client_bol_show_contract_product_without_price,
      client_bol_allow_sell_spot_itens_without_stock,
      client_bol_client_withdraw,
      client_bol_delivery_address_type,
      client_bol_internal_delivery_address,
      emailsEkam,
    } = this.state.form;
    const { form, permissions } = this.state;
    const { goalOff } = this.props;

    form.client_bol_display_client_description = client_bol_display_client_description
      ? Number(client_bol_display_client_description) : '';
    form.client_bol_show_contract_product_without_price = client_bol_show_contract_product_without_price
      ? Number(client_bol_show_contract_product_without_price) : 0;
    form.client_bol_allow_sell_spot_itens_without_stock = client_bol_allow_sell_spot_itens_without_stock
      ? Number(client_bol_allow_sell_spot_itens_without_stock) : 0;
    form.client_bol_client_withdraw = client_bol_client_withdraw
      ? Number(client_bol_client_withdraw) : 0;
    form.client_bol_delivery_address_type = client_bol_delivery_address_type
      ? Number(client_bol_delivery_address_type) : 0;
    form.client_bol_internal_delivery_address = client_bol_internal_delivery_address
      ? Number(client_bol_internal_delivery_address) : 0;
    form.emailsEkam = emailsEkam;

    permissions.user_client_bol_permission_cart = permissions.user_client_bol_permission_cart ? 1 : 0;
    permissions.user_client_bol_permission_cart_users = permissions.user_client_bol_permission_cart_users ? 1 : 0;
    permissions.user_client_bol_permission_purchase_credit = permissions.user_client_bol_permission_purchase_credit ? 1 : 0;
    permissions.user_client_bol_permission_purchase_payment_gateway = permissions.user_client_bol_permission_purchase_payment_gateway ? 1 : 0;
    permissions.user_client_bol_permission_purchase_debit = permissions.user_client_bol_permission_purchase_debit ? 1 : 0;
    permissions.user_client_bol_permission_purchase_bank_slip = permissions.user_client_bol_permission_purchase_bank_slip ? 1 : 0;
    permissions.user_client_bol_permission_purchase_billing = permissions.user_client_bol_permission_purchase_billing ? 1 : 0;
    permissions.user_client_bol_permission_purchase_estimate = permissions.user_client_bol_permission_purchase_estimate ? 1 : 0;
    permissions.user_client_bol_permission_similarity = permissions.user_client_bol_permission_similarity ? 1 : 0;
    permissions.user_client_bol_permission_stock = permissions.user_client_bol_permission_stock ? 1 : 0;
    permissions.user_client_bol_permission_lead_time = permissions.user_client_bol_permission_lead_time ? 1 : 0;
    permissions.user_client_bol_permission_cross_selling = permissions.user_client_bol_permission_cross_selling ? 1 : 0;
    permissions.user_client_bol_permission_price = permissions.user_client_bol_permission_price ? 1 : 0;
    permissions.user_client_bol_permission_client_code = permissions.user_client_bol_permission_client_code ? 1 : 0;
    permissions.user_client_bol_permission_spot = permissions.user_client_bol_permission_spot ? 1 : 0;
    permissions.user_client_bol_permission_opic_code = permissions.user_client_bol_permission_opic_code ? 1 : 0;
    permissions.user_client_bol_permission_sonepar_code = permissions.user_client_bol_permission_sonepar_code ? 1 : 0;
    permissions.user_client_bol_permission_visualize_all_orders = permissions.user_client_bol_permission_visualize_all_orders ? 1 : 0;
    permissions.user_client_bol_permission_allow_mixed_purchase = permissions.user_client_bol_permission_allow_mixed_purchase ? 1 : 0;

    const client = await VALIDATION.validation(form, goalOff, this.props.companyTag);
    if (client.message) {
      this.setState({ message: client.message, success: '' });
    } else {
      try {
        await this.props.updateNewUsersParams({ ...client, ...permissions });
        this.setState({ success: I18n.t('successActualized'), message: '' });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  selectedItem = (attr, value) => {
    const { form } = this.state;
    if (attr === 'client_bol_file_email_xml') {
      if (form.client_bol_file_email_xml) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'client_bol_file_email_csv') {
      if (form.client_bol_file_email_csv) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'client_bol_file_email_pdf') {
      if (form.client_bol_file_email_pdf) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'client_bol_file_email_json') {
      if (form.client_bol_file_email_json) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'client_str_location') {
      if (!value.target.id) {
        form[attr] = value.target.value;
      } else {
        const clientStrLocation = JSON.parse(form[attr]);
        if (value.target.id === 'clienteSaoPaulo') {
          clientStrLocation.SP = value.target.value;
          form[attr] = JSON.stringify(clientStrLocation);
        } else if (value.target.id === 'clienteForaSaoPaulo') {
          clientStrLocation.OUTROS = value.target.value;
          form[attr] = JSON.stringify(clientStrLocation);
        }
      }
    } else form[attr] = value.target.value;

    this.setState({ form, message: '', success: '' });
  }

  renameDepositKeyForComponent = async (client) => {
    if (!this.state.listClient) {
      client.forEach((x) => {
        x.name = (x.value).toUpperCase();
        x.value = (x.name).toUpperCase();
      });

      await this.setState({ listClient: client });
    }
  }

  result = async (params) => {
    const { form } = this.state;
    form.client_str_deposit = params.toString();
    await this.setState({
      form,
      checked: params,
      message: '',
      success: '',
    });
  }

  render() {
    const {
      message, success, listClient, checked, inputsStateDisabled, permissions, inputsLabel,
    } = this.state;
    const {
      client_str_freight, client_str_location, client_str_bu, client_bol_file_email_xml,
      client_bol_file_email_json, client_int_price_policy, client_bol_display_client_description, client_str_purpose,
      client_str_buy_button_label, client_bol_file_email_pdf, client_bol_file_email_csv,
      client_bol_show_contract_product_without_price, client_bol_allow_sell_spot_itens_without_stock,
      client_bol_client_withdraw, client_flo_minimum_purchase, client_flo_minimum_product, client_bol_automatic_billing,
      client_bol_delivery_address_type, client_bol_internal_delivery_address, emailsEkam,
    } = this.state.form;
    const {
      clients, goalOff, opico, companyTag,
    } = this.props;

    return (
      <div>
        {clients
          && this.getSelectComponent(
            I18n.t('freightType'),
            'client_str_freight',
            client_str_freight,
            this.getObjValues(clients.ClientFreights, 'freight'),
            I18n.t('freightTypeObs'),
          )}

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="ekam" />
          </p>
          <textarea
            value={emailsEkam}
            onChange={e => this.selectedItem('emailsEkam', e)}
            className="form-control"
            placeholder={I18n.t('separateBySemicolon')}
            rows="3"
          />
        </div>

        {/* {clients && companyTag !== 'nortel' && this.getSelectComponent(
          I18n.t('place'),
          'client_str_location',
          client_str_location,
          this.getValuesLocation(clients.location),
        )} */}

        {/* {clients && this.getSelectComponent(I18n.t('bu'), 'client_str_bu', client_str_bu, this.getValues(clients.bus))} */}

        {/* {clients && companyTag !== 'chile' && this.getSelectComponent(I18n.t('policy'), 'client_int_price_policy',
          client_int_price_policy, this.getValues(clients.pricePolicies))} */}

        {/* {clients && companyTag === 'chile'
          && (
          <span>
            <p className="margin-bottom-2">{I18n.t('policy')}</p>
            <Select
              onChange={(e) => {
                const { form } = this.state;
                form.client_int_price_policy = e.value;
                this.setState({ form, message: '', success: '' });
              }}
              options={this.getValuesObj(clients.pricePolicies)}
              value={{ label: clients && (clients.pricePolicies.find(val => val.id == client_int_price_policy) || []).description, value: client_int_price_policy }}
            />
            <p />
          </span>
          )
        } */}

        {/* {clients && !goalOff && this.getSelectComponent(I18n.t('purpose'), 'client_str_purpose',
          client_str_purpose, this.getObjValues(clients.ClientPurposes, 'purpose'))} */}

        <div className="row row-solicitation-check">
          <div className="form-check" style={{ marginRight: '5px' }}>
            <input
              onChange={e => this.selectedItem('client_bol_file_email_xml', e)
              }
              type="checkbox"
              className="form-check-input"
              checked={!!client_bol_file_email_xml}
              id="exampleCheck1"
            />
            <span>XML</span>
          </div>

          <div className="form-check" style={{ marginRight: '5px' }}>
            <input
              onChange={e => this.selectedItem('client_bol_file_email_csv', e)
              }
              type="checkbox"
              className="form-check-input"
              checked={!!client_bol_file_email_csv}
              id="exampleCheck1"
            />
            <span>CSV</span>
          </div>

          <div className="form-check" style={{ marginRight: '5px' }}>
            <input
              onChange={e => this.selectedItem('client_bol_file_email_pdf', e)
              }
              type="checkbox"
              className="form-check-input"
              checked={!!client_bol_file_email_pdf}
              id="exampleCheck1"
            />
            <span>PDF</span>
          </div>

          <div className="form-check" style={{ marginRight: '5px' }}>
            <input
              onChange={e => this.selectedItem('client_bol_file_email_json', e)
              }
              type="checkbox"
              className="form-check-input"
              checked={!!client_bol_file_email_json}
              id="exampleCheck1"
            />
            <span>JSON</span>
          </div>
        </div>

        {/* {listClient && checked && (
          <div className="form-group">
            <p style={{ marginBottom: '0px' }} className="margin-bottom-2"><Translate value="deposit" /></p>
            <MultiSelect
              options={listClient}
              checked={checked}
              onSelectOptions={this.result}
              className="form-control multiSelect-input"
            />
          </div>
        )}

        {listClient && !checked && (
          <div className="form-group">
            <p style={{ marginBottom: '0px' }} className="margin-bottom-2"><Translate value="deposit" /></p>
            <MultiSelect
              options={listClient}
              checked={[]}
              onSelectOptions={this.result}
              className="form-control multiSelect-input"
            />
          </div>
        )} */}

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="buyButton" />
          </p>
          <input
            onChange={e => this.selectedItem('client_str_buy_button_label', e)
            }
            type="text"
            className="form-control"
            aria-describedby="botãoComprar"
            placeholder=""
            value={client_str_buy_button_label}
            maxLength={FIELDS.default}
          />
        </div>

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="showClientDescription" />
          </p>
          <select
            onChange={e => this.selectedItem('client_bol_display_client_description', e)
            }
            className="custom-select"
            value={client_bol_display_client_description}
            required
          >
            <option value="" />
            <option value="1">{I18n.t('yes')}</option>
            <option value="0">{I18n.t('no')}</option>
          </select>
        </div>

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="showContractProductWithoutPrice" />
          </p>
          <select
            onChange={e => this.selectedItem(
              'client_bol_show_contract_product_without_price',
              e,
            )
            }
            className="custom-select"
            value={client_bol_show_contract_product_without_price}
            required
          >
            <option value="" />
            <option value="1">{I18n.t('yes')}</option>
            <option value="0">{I18n.t('no')}</option>
          </select>
        </div>

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="allowSellSpotItensWithoutStock" />
          </p>
          <select
            onChange={e => this.selectedItem(
              'client_bol_allow_sell_spot_itens_without_stock',
              e,
            )
            }
            className="custom-select"
            value={Number(client_bol_allow_sell_spot_itens_without_stock)}
            required
          >
            <option value="" />
            <option value="1">{I18n.t('yes')}</option>
            <option value="0">{I18n.t('no')}</option>
          </select>
        </div>

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="clientWithdraw" />
          </p>
          <select
            onChange={e => this.selectedItem('client_bol_client_withdraw', e)}
            className="custom-select"
            value={Number(client_bol_client_withdraw)}
            required
          >
            <option value="" />
            <option value="1">{I18n.t('yes')}</option>
            <option value="0">{I18n.t('no')}</option>
          </select>
        </div>

        {companyTag === 'nortel' && (
          <React.Fragment>
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="clientSolicitationType" />
              </p>
              <select
                onChange={event => this.selectedItem('client_bol_delivery_address_type', event)
                }
                className="custom-select"
                value={Number(client_bol_delivery_address_type)}
                required
              >
                <option value="" />
                <option value="1">{I18n.t('yes')}</option>
                <option value="0">{I18n.t('no')}</option>
              </select>
            </div>
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="identifyInternalDeliveryLocation" />
              </p>
              <select
                onChange={event => this.selectedItem(
                  'client_bol_internal_delivery_address',
                  event,
                )
                }
                className="custom-select"
                value={Number(client_bol_internal_delivery_address)}
                required
              >
                <option value="" />
                <option value="1">{I18n.t('yes')}</option>
                <option value="0">{I18n.t('no')}</option>
              </select>
            </div>
          </React.Fragment>
        )}

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="clientAutoBilling" />
          </p>
          <select
            onChange={e => this.selectedItem('client_bol_automatic_billing', e)
            }
            className="custom-select"
            value={Number(client_bol_automatic_billing)}
            required
          >
            <option value="" />
            <option value="1">{I18n.t('yes')}</option>
            <option value="0">{I18n.t('no')}</option>
          </select>
        </div>

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="clientMinimumPurchase" />
          </p>
          <p>
            <NumberFormat
              className="limit-input"
              value={Number(client_flo_minimum_purchase)}
              prefix={`${I18n.t('monetarySymbolPrefix')}`}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              onValueChange={e => this.setMinimumPurchase(e)}
            />
          </p>
        </div>

        <div className="form-group">
          <p className="margin-bottom-2">
            <Translate value="clientMinimumProduct" />
          </p>
          <p>
            <NumberFormat
              className="limit-input"
              value={Number(client_flo_minimum_product)}
              prefix={`${I18n.t('monetarySymbolPrefix')}`}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              onValueChange={e => this.setMinimumProduct(e)}
            />
          </p>
        </div>

        <div className="row margin-bottom-20" style={{ marginTop: 10 }}>
          <Checkbox
            onCheckBox={this.onCheckBox}
            permissions={permissions}
            config={config}
            inputsStateDisabled={inputsStateDisabled}
            inputsLabel={inputsLabel}
            translate
            companyTag={this.props.settings.companyTag}
            billetOff={this.props.settings.billetOff}
            opicName={opico}
          />
        </div>
        <button
          onClick={() => this.saveClient()}
          type="button"
          className="btn btn-secondary margin-bottom-20"
        >
          <Translate value="save" />
        </button>
        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  clients: state.clients.clientsSettings,
  settings: state.settings,
  goalOff: state.settings.goalOff,
  opico: state.settings.name,
  companyTag: state.settings.companyTag,
});

const mapDispatchToProps = dispatch => ({
  loadSettings: dispatch(loadSettings()),
  updateNewUsersParams: (params) => { dispatch(updateNewUsersParams(params)); },
  getClientSettings: () => { dispatch(ClientsAction.getClientSettings()); },
});

export default connect(mapStateToProps, mapDispatchToProps)(NewUsersComponent);
